<template>
  <div>
    <div
      class="frisbuy-summary-widget"
      :class="{
        'frisbuy-summary-widget--bordered': true || props.isBordered,
        'frisbuy-summary-widget--icon-hidden':
          props.viewSettings.isHideFrisbuyIcon,
      }"
      @click="emit('swipeToMarket')"
    >
      <slot name="arrow" />
      <slot name="header" />
      <slot name="content" />
      <slot name="tags" />
      <slot name="ai-2" />
      <slot name="logo" />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface ViewSettings {
  type: number;
  isHideFrisbuyIcon: boolean;
  trigger?: string;
  placement?: string;
  openDelay?: number;
  closeDelay?: number;
  offset?: number;
}

const props = defineProps<{
  isBordered?: boolean;
  viewSettings: ViewSettings;
}>();
const emit = defineEmits(["swipeToMarket"]);
</script>
